var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-edit-layout',[_c('robot-department-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item}}),(this.item != null)?_c('div',[_c('listRobotDepartment',{attrs:{"robo_id":_vm.id}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }